import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const Portfolio = () => {
  const projects = [
    {
      title: "Sistema de Gestão Empresarial",
      category: "ERP",
      description: "Plataforma completa de gestão com módulos financeiro, estoque, vendas e RH integrados.",
      tags: ["React", "Node.js", "PostgreSQL"],
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500&q=80&fm=webp"
    },
    {
      title: "App Delivery Mobile",
      category: "Mobile",
      description: "Aplicativo de delivery com rastreamento em tempo real e sistema de pagamento integrado.",
      tags: ["React Native", "Firebase", "Stripe"],
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=500&q=80&fm=webp"
    },
    {
      title: "E-commerce Fashion",
      category: "Web",
      description: "Loja virtual moderna com catálogo dinâmico, carrinho inteligente e checkout simplificado.",
      tags: ["Next.js", "Tailwind", "Shopify"],
      image: "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?w=500&q=80&fm=webp"
    },
    {
      title: "Chatbot com IA",
      category: "IA",
      description: "Assistente virtual inteligente para atendimento 24/7 com processamento de linguagem natural.",
      tags: ["Python", "OpenAI", "LangChain"],
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=500&q=80&fm=webp"
    },
    {
      title: "Sistema Datacaixa",
      category: "Parceria",
      description: "Frente de caixa completo com integração fiscal, PDV e gestão de vendas.",
      tags: ["Delphi", "SQL Server", "NF-e"],
      image: "https://images.unsplash.com/photo-1556155092-490a1ba16284?w=500&q=80&fm=webp"
    },
    {
      title: "Link Pro - Gestão de Links",
      category: "Parceria",
      description: "Plataforma profissional para criação de bio links personalizados e analytics.",
      tags: ["React", "Analytics", "QR Code"],
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500&q=80&fm=webp"
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Nosso <span className="text-primary">Portfólio</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Projetos que transformaram negócios e geraram resultados reais
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <Card 
              key={index}
              className="overflow-hidden group hover:shadow-2xl transition-all duration-300 card-shadow hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden bg-muted">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=500&q=80&fm=webp';
                    e.currentTarget.onerror = null;
                  }}
                />
              </div>
              
              <div className="p-6">
                <Badge variant="secondary" className="mb-3">{project.category}</Badge>
                <h3 className="text-xl font-bold mb-2">{project.title}</h3>
                <p className="text-muted-foreground mb-4 leading-relaxed">{project.description}</p>
                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag, tagIndex) => (
                    <Badge key={tagIndex} variant="outline" className="text-xs">
                      {tag}
                    </Badge>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
